const state = {
  pageAttributesInPageOptions: 0,
  matrixComplete: false,
  showUpload: false,
  personalizationFullPage: true,
  addToCartFullPage: false,
  disableDeleteUploadAfterConnect: false,
  listenScroll: false
};

const getters = {
  getListenScroll(state) {
    return state.listenScroll;
  },
  getDisableDeleteUploadAfterConnect: state => {
    return state.disableDeleteUploadAfterConnect;
  },
  getPageAttributesInPageOptions: state => {
    return state.pageAttributesInPageOptions;
  },
  getMatrixComplete: state => {
    return state.matrixComplete;
  },
  getShowUpload: state => {
    return state.showUpload;
  },
  getPersonalizationFullPage: state => {
    return state.personalizationFullPage;
  },
  getAddToCartFullPage: state => {
    return state.addToCartFullPage;
  }
};

const mutations = {
  setListenScroll: (state, payload) => {
    state.listenScroll = payload;
  },
  setMatrixComplete: (state, payload) => {
    state.matrixComplete = payload;
  },
  setShowUpload: (state, payload) => {
    state.showUpload = payload;
  },
  setPersonalizationFullPage: (state, payload) => {
    state.personalizationFullPage = payload;
  },
  setAddToCartFullPage: (state, payload) => {
    state.addToCartFullPage = payload;
  },
  setDisableDeleteUploadAfterConnect: (state, payload) => {
    state.disableDeleteUploadAfterConnect = payload;
  }
};

const actions = {
  setMatrixComplete: ({ commit }, payload) => {
    commit("setMatrixComplete", payload);
    commit("setShowUpload", payload);
  },
  setShowUpload: ({ commit }, payload) => {
    commit("setShowUpload", payload);
  },
  setPersonalizationFullPage: ({ commit }, payload) => {
    commit("setPersonalizationFullPage", payload);
  },
  setAddToCartFullPage: ({ commit }, payload) => {
    commit("setAddToCartFullPage", payload);
  },
  setDisableDeleteUploadAfterConnect: ({ commit }, payload) => {
    commit("setDisableDeleteUploadAfterConnect", payload);
  },
  onScrollEvent: ({ commit, getters }, payload) => {
    if (!getters.getListenScroll) {
      return;
    }
    onScrollEventPosition(getters);
  },
  setListenScroll: ({ commit, getters }, payload) => {
    commit("setListenScroll", payload);
    setTimeout(() => {
      onScrollEventPosition(getters);
    }, 1000);
  }
};

const onScrollEventPosition = getters => {
  if (getters.getIsMobile) {
    jQuery("#" + getters.getSelector + " .vld-icon").css("top", "30%");
    return;
  }
  const bounding = document
    .getElementById(getters.getSelector)
    .getBoundingClientRect();
  const viewportHeight = window.innerHeight;
  let top = viewportHeight - bounding.top;
  if (bounding.top < 0) {
    if (bounding.bottom > viewportHeight) {
      // element is full inside the viewport, so add the element in the middle
      top = -1 * bounding.top + viewportHeight / 2;
    } else {
      let offset = bounding.bottom / 2;
      top = -1 * bounding.top + offset;
    }
  } else {
    if (bounding.bottom > viewportHeight) {
      let offset = (viewportHeight - bounding.top) / 2;
      top = offset;
    } else {
      top = bounding.height / 2;
    }
  }
  top -= 50;
  jQuery("#" + getters.getSelector + " .vld-icon").css("top", top + "px");
};

export default {
  state,
  mutations,
  actions,
  getters
};
